<template>
  <router-view />
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

:root {
  /* Minimalist Light Theme */
  --bg-primary: #ffffff; /* Clean white */
  --bg-secondary: #f4f4f5; /* Zinc 100 */
  --bg-tertiary: #e4e4e7; /* Zinc 200 */
  --bg-card: #ffffff;
  --bg-glass: rgba(255, 255, 255, 0.7);

  --text-primary: #09090b; /* Zinc 950 */
  --text-secondary: #52525b; /* Zinc 600 */
  --text-muted: #a1a1aa; /* Zinc 400 */

  --accent-primary: #18181b; /* Zinc 900 */
  --accent-secondary: #27272a; /* Zinc 800 */
  
  --border-dim: rgba(0, 0, 0, 0.08);
  --border-active: rgba(0, 0, 0, 0.15);

  --font-mono: 'JetBrains Mono', monospace;
  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: var(--font-sans);
  scroll-behavior: smooth;
  font-size: 16px;
}

body {
  margin: 0;
  padding: 0;
  background: var(--bg-primary);
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
  background: var(--bg-primary);
  display: flex;
  flex-direction: column;
}

::selection {
  background: rgba(0, 0, 0, 0.1);
  color: var(--text-primary);
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: var(--bg-primary); 
}
::-webkit-scrollbar-thumb {
  background: var(--bg-tertiary); 
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted); 
}
</style>
